export const MODEL_NAMES = [
  'Account',
  'AccountUser',
  'Article',
  'Campaign',
  'Category',
  'Channel::Api',
  'Channel::Email',
  'Channel::FacebookPage',
  'Channel::Instagram',
  'Channel::Line',
  'Channel::Sms',
  'Channel::Telegram',
  'Channel::TwilioSms',
  'Channel::TwitterProfile',
  'Channel::WebWidget',
  'Channel::Whatsapp',
  'Contact',
  'Conversation',
  'CustomAttributeDefinition',
  'CustomFilter',
  'DashboardApp',
  'DataImport',
  'Folder',
  'Inbox',
  'InboxMember',
  'Label',
  'Macro',
  'Note',
  'Portal',
  'RelatedCategory',
  'Team',
  'TeamMember',
  'User',
  'Webhook',
  'WgptAutomation',
  'WgptBoard',
  'WgptBoardList',
  'WgptBoardListCard',
  'WgptBoardListCardActivity',
  'WgptBot',
  'WgptBotEvalCriterion',
  'WgptBotSource',
  'WgptBotSourceChunk',
  'WgptBotTool',
  'WgptBotWorkflow',
  'WgptBotWorkflowStage',
  'WgptCampaign',
  'WgptTask',
  'WorkingHour',
];

export const MODEL_ROUTES_MAP = {
  Conversation: {
    name: 'inbox_conversation',
    paramKey: 'conversation_id',
  },
  Contact: {
    name: 'contacts_edit',
    paramKey: 'contactId',
  },
  WgptBoard: {
    name: 'board_item',
    paramKey: 'boardId',
  },
  WgptBot: {
    name: 'wgpt_bots_edit',
    paramKey: 'botId',
  },
  WgptCampaign: {
    name: 'wgpt_campaigns_editor',
    paramKey: 'campaignId',
  },
};
